import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React, { useEffect, useRef, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Alert from '@material-ui/lab/Alert';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Chip from '@material-ui/core/Chip';
import LocationDataService from '../../services/LocationService';
import { AutoDisabler, Validate, ValidationGroup } from 'mui-validate';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(0.5),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    root: props => ({
        flexGrow: 1,
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '31.2ch',
        },
        '& .MuiButton-root': {
            margin: theme.spacing(1),
        },
        '& .MuiAlert-root': {
            width: '100%',
            '& > * + *': {
                marginTop: theme.spacing(1),
            },
        },
    }),
    small: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '29ch',
        },
        '& .MuiButton-root': {
            margin: theme.spacing(1),
        },
    },
    paper: {
        textAlign: 'center',
    },
    item: {
        height: '95%',
        alignItems: 'center',
    },
    chips: {
        '& > *': {
            margin: theme.spacing(0.5),
        },
        height: '20rem',
        overflow: 'scroll',
    },
}));

function LocationForm() {
    const classes = useStyles();
    const { t } = useTranslation();

    const [loc] = React.useState(() => {
        const locData = localStorage.getItem('loc');
        return locData ? JSON.parse(locData).id : '';
    });

    const handleInputChange = event => {
        const { name, value } = event.target;
        setLocation({ ...location, [name]: value });
    };

    const [locationMessage, setLocationMessage] = useState('');
    const initialLocationState = {
        id: null,
        name: '',
    };

    const [location, setLocation] = useState(initialLocationState);
    const [submitted, setSubmitted] = useState(false);

    const saveLocation = () => {
        var data = {
            name: location.name,
            number: biggestLocNum + 1,
        };

        LocationDataService.create(data)
            .then(response => {
                setLocation({
                    id: response.data.id,
                    name: response.data.name,
                    number: response.data.number,
                });
                setSubmitted(true);
                setLocationMessage(
                    <Alert severity="success">
                        {t('companyData.locations.success')}
                    </Alert>
                );
                console.log(response.data);
                retrieveLocations();
                setTimeout(() => {
                    retrieveDeletedLocations();
                    setLocationMessage();
                }, 2500);
            })
            .catch(e => {
                console.log(e);
                setLocationMessage(
                    <Alert severity="error">
                        {t('companyData.locations.error')}
                    </Alert>
                );
            });
    };

    const [locations, setLocations] = useState([]);
    const [biggestLocNum, setBiggestLocNum] = useState([]);

    useEffect(() => {
        retrieveLocations();
        retrieveDeletedLocations();
        // const interval = setInterval(() => {
        //     retrieveDeletedLocations()
        // }, 5000);
        // return () => clearInterval(interval);
    }, []);

    const retrieveLocations = () => {
        const locData = JSON.parse(localStorage.getItem('loc'));

        LocationDataService.getAll()
            .then(response => {
                let filteredLocations;

                if (locData && locData.id === 'all') {
                    // Show all locations
                    filteredLocations = response.data;
                } else if (Array.isArray(locData)) {
                    // Filter locations based on the locData array
                    filteredLocations = response.data.filter(location =>
                        locData.includes(location.id)
                    );
                } else {
                    // If locData is invalid or not present, show no locations
                    filteredLocations = [];
                }

                setLocations(filteredLocations);
                console.log(filteredLocations);
            })
            .catch(e => {
                console.log(e);
            });
    };

    const retrieveDeletedLocations = () => {
        LocationDataService.getAllDeleted()
            .then(response => {
                var arrObjIds = response.data.map(elements => {
                    return elements.number;
                });
                var maxId = Math.max(...arrObjIds);
                setBiggestLocNum(maxId);
            })
            .catch(e => {
                console.log(e);
            });
    };

    const handleDelete = id => {
        LocationDataService.remove(id)
            .then(response => {
                if (response.data) {
                    // Check if response is successful
                    setLocationMessage(
                        <Alert severity="success">
                            {t('companyData.locations.removalSuccess')}
                        </Alert>
                    );
                    console.log(response.data);
                    window.location.reload();
                    setTimeout(() => {
                        setLocationMessage();
                    }, 2500);
                }
            })
            .catch(e => {
                console.log(e);
                setLocationMessage(
                    <Alert severity="error">
                        {t('companyData.locations.removalError')}
                    </Alert>
                );
                setTimeout(() => {
                    setLocationMessage();
                }, 2500);
            });
    };

    const ref = useRef(null);

    return (
        <Card className={classes.item}>
            <AppBar position="static" elevation={0} color="primary">
                <Toolbar className="px-8">
                    <Typography
                        variant="subtitle1"
                        color="inherit"
                        className="flex-1 px-12"
                    >
                        {t('companyData.locations.title')}
                    </Typography>
                </Toolbar>
            </AppBar>
            {locationMessage}
            <CardContent>
                <div className="edit-form">
                    <form className={classes.small}>
                        <ValidationGroup>
                            <Validate
                                name="name"
                                required={[
                                    true,
                                    t('companyData.locations.required'),
                                ]}
                                regex={[
                                    /^[A-Za-zА-Яа-яЁёЇїІіЄєҐґ0-9 ]*$/, // Updated regex to include Cyrillic characters
                                    t('companyData.locations.locationRegex'),
                                ]}
                            >
                                <TextField
                                    required
                                    id="outlined-required name"
                                    label={t('companyData.locations.location')}
                                    variant="outlined"
                                    name="name"
                                    value={location.name}
                                    onChange={handleInputChange}
                                    size="small"
                                />
                            </Validate>
                            <AutoDisabler>
                                <Button
                                    onClick={saveLocation}
                                    variant="contained"
                                    color="primary"
                                >
                                    {t('companyData.locations.create')}
                                </Button>
                            </AutoDisabler>
                        </ValidationGroup>
                    </form>
                </div>
                <div className={classes.chips}>
                    {locations.map(location => (
                        <Chip
                            ref={ref}
                            id={location.id}
                            onDelete={
                                locations.length > 1
                                    ? () => handleDelete(location.id)
                                    : undefined
                            }
                            label={location.name}
                        />
                    ))}
                </div>
            </CardContent>
        </Card>
    );
}

export default LocationForm;
